<template>
  <b-modal
    ref="modal"
    centered
    hide-footer
    static
    size="lg"
    class="review-form modal-form"
  >
    <b-img
      slot="modal-header-close"
      :src="require('@/assets/icons/x-b.svg')"
      width="45"
      height="30"
    ></b-img>

    <b-form class="form" @submit.prevent="onSubmit">
      <div class="form__section">
        <h3 class="page-subtitle">Rate this tool</h3>
        <b-form-group>
          <rate
            v-model="form.rating"
            :disabled="!!review"
            :has-label="false"
            size="lg"
          ></rate>
        </b-form-group>
      </div>
      <div class="form__section">
        <h3 class="page-subtitle">Leave a review</h3>
        <b-form-group>
          <b-textarea
            v-model="form.text"
            :readonly="!!review"
            :state="form.$getError('text')"
          ></b-textarea>
          <error-message :error="form.$getError('text')"></error-message>
        </b-form-group>
      </div>

      <error-message
        class="mb-4"
        sign=""
        :error="form.$errorMessage"
      ></error-message>

      <div v-if="!review" class="review__footer form__section mb-0">
        <b-button
          type="submit"
          block
          variant="primary"
          :disabled="!isSubmittable || form.$busy"
        >
          <b-spinner small v-if="form.$busy"></b-spinner>
          Send</b-button
        >
      </div>
    </b-form>
  </b-modal>
</template>
<script>
/**
 * ==================================================================================
 * Review form
 * ==================================================================================
 **/

import { mapActions } from 'vuex'
import Transaction from '@/models/Transaction'
import Form from '@/utils/form'
import Rate from '@/components/inputs/Rate'
import ErrorMessage from '@/components/inputs/ErrorMessage'

export default {
  components: {
    Rate,
    ErrorMessage
  },
  props: {
    transaction: {
      type: [Transaction, Object]
    }
  },
  computed: {
    review() {
      return this.transaction ? this.transaction.review : {}
    },

    isSubmittable() {
      return this.form.rating > 0 && this.form.text
    }
  },
  watch: {
    transaction(value) {
      if (value) {
        this.setReview()
      }
    }
  },
  data: function() {
    return {
      form: new Form({
        rating: 0,
        text: null
      })
    }
  },
  methods: {
    ...mapActions({
      createReview: 'review/createReview',
      addAlert: 'alert/addAlert'
    }),

    async onSubmit() {
      if (this.form.$busy) return
      this.form.$setLoading(true)
      await this.createReview(this.getFormData())
        .then(() => {
          this.form.$setLoading(false)
          window.location.reload()
        })
        .catch(error => {
          this.form.$setLoading(false)
          this.form.$handleError(error)
        })
    },

    getFormData() {
      return {
        id: this.transaction.tool.permalink,
        rating: this.form.rating,
        text: this.form.text,
        renter_code: this.transaction.renter_code
      }
    },

    setReview() {
      if (this.review) {
        this.form.rating = this.review.rating
        this.form.text = this.review.text
      }
    },

    show() {
      this.$refs.modal.show()
    },
    close() {
      this.$refs.modal.hide()
    }
  },

  created() {
    this.setReview()
  }
}
</script>
<style scoped lang="scss">
.review-form /deep/ {
  textarea {
    height: 100px;
    min-height: auto;
  }

  .review__footer {
    button {
      width: 80%;
      min-width: 400px;
      margin: 0 auto;
    }
  }
}

@media (max-width: 568px) {
  .review-form {
    .review__footer {
      button {
        width: 100%;
        min-width: inherit;
      }
    }
  }
}
</style>
